import { ContentTypeEnum } from '@/enums/axios'
import request from '@/utils/axios'

const jsonHeaderConfig = {
  headers: {
    'Content-Type': ContentTypeEnum.JSON
  }
}

// 获取公海下来列表
export const getSeaSelectApi = (data?: any) => {
  return request.get('/crm/track/seaManage/getSeaSelect', data, jsonHeaderConfig)
}
// 公海排序

export const seaOrderSave = (data?: any) => {
  return request.post('/crm/track/seaManage/seaOrderSave', data)
}
// 公海领取
export const seaReceive = (data?: any) => {
  return request.post('/crm/track/sea/claim', data, jsonHeaderConfig)
}
// 公海领取多个5
export const seaReceiveSync = (data?: any) => {
  return request.post('/crm-report/track/sea/sync/claim', data, jsonHeaderConfig)
}

// 公海删除
export const highSeaDelete = (data?: any) =>
  request.delete('/crm/track/sea/del', data, jsonHeaderConfig)
// 公海转移
export const highSeaTransfer = (data?: any) =>
  request.post('/crm-report/track/sea/bulk/transfer', data, jsonHeaderConfig)
// 公海客户详情基本信息
export const highSeaBaseInfoApi = (data?: any) =>
  request.post('/crm/track/sea/baseInfo', data, jsonHeaderConfig)
// 公海分配
export const highSeaDistribute = (data?: any) =>
  request.post('/crm-report/track/sea/allocate', data, jsonHeaderConfig)
// 公海客户详情
export const highSeaDetailApi = (data?: any, options = undefined) =>
  request.get('/crm/track/sea/orderInfo', data, options)
